import PasswordForm from "../../../routes/csr/change-password/password-form";
import ET3Div from "../../et3-div";
import { withLiteObserverAndTheme } from "../../et3-enhanced-render";

const ChangePasswordPopUp = withLiteObserverAndTheme<{ width: number }>(
  (props) => {
    const { theme, width } = props;
    const { colors } = theme;

    return (
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={width}
        height={1080}
        fDirection="row"
        alignItems="center"
        justifyContent="center"
        color={colors.all.transparentGray}
        style={{
          position: "fixed",
          top: 0,
          zIndex: 5
        }}
        onClick={() => {}}
      >
        <ET3Div
          isScrollable={false}
          isExtendable={true}
          withShadow={true}
          width={500}
          height={500}
          fDirection="column"
          alignItems="center"
          justifyContent="center"
          color={colors.all.white}
          style={{
            position: "relative",
            borderRadius: 20
          }}
          onClick={() => {}}
        >
          <ET3Div
            isScrollable={false}
            isExtendable={true}
            withShadow={false}
            width={300}
            height={300}
            fDirection="column"
            alignItems="flex-start"
            justifyContent="flex-start"
            color={colors.all.transparent}
            style={{}}
            onClick={() => {}}
          >
            <PasswordForm />
          </ET3Div>
        </ET3Div>
      </ET3Div>
    );
  }
);
export default ChangePasswordPopUp;
